<template>
  <base-modal
		ref="$modal"
		:loading="isLoading"
		width="900px"
		height="800px"
		@on-close="isActive = false"
  >
    <app-tabs-old :tabs="tabs" v-model="activeTab">
      <template #info>
        <div v-if="!isLoading && projectInfo" class="project-info">
          <div class="project-info__header">
            <div class="project-info__header-left">
              <div class="project-info__field">
                <span class="project-info__field-name">Проект: </span>
                <span class="project-info__field-value">{{
                  projectPage.project?.Name
                }}</span>
              </div>
              <div class="project-info__field">
                <span class="project-info__field-name">Создан: </span>
                <span class="project-info__field-value">{{
                  formatDate(projectInfo.CreateTime)
                }}</span>
                <span
                  v-if="projectInfo.Creator?.Name"
                  class="project-info__field-value"
                >
                  [{{ projectInfo.Creator.Name }}]</span
                >
              </div>
              <div class="project-info__field">
                <span class="project-info__field-name"
                  >Последнее редактирование:
                </span>
                <span class="project-info__field-value">{{
                  formatDate(projectInfo.ChangeTime)
                }}</span>
                <span
                  v-if="projectInfo.Changer?.Name"
                  class="project-info__field-value"
                >
                  [{{ projectInfo.Changer.Name }}]</span
                >
              </div>

              <div v-if="tags.length" class="project-info__field">
                <span class="project-info__field-name">Теги: </span>
                <span class="project-info__field-value">
                  {{ tags.map((t) => `#${t.Name}`).join(", ") }}
                </span>
              </div>
            </div>

            <div class="project-info__header-right">
              <app-lists
                ref="$lists"
                v-model="projectInfo.AnalyticsLists"
                :segment="PROJECT_SEGMENT"
                :element-id="projectIdRef"
              />
            </div>
          </div>

          <div class="project-info__records">
            <div
              v-if="projectInfo.StageChangeRecords?.length"
              class="project-info__field project-info__field--col"
            >
              <div class="project-info__field-name">Смена этапов:</div>
              <div
                v-for="(r, idx) in projectInfo.StageChangeRecords"
                :key="`s-${idx}`"
                class="project-info__field-value-col"
              >
                <span class="project-info__field-value-col-time"
                  >{{ formatDate(r.Date) }}&nbsp;</span
                >
                <span class="project-info__field-value-col-action">
                  [{{ r.Creator?.Name }}] переведено в «{{ r.StageName }}»
                </span>
              </div>
            </div>

            <div
              v-if="projectInfo.WorkerAttachmentLogs?.length"
              class="project-info__field project-info__field--col"
            >
              <div class="project-info__field-name">Пользователи и роли:</div>
              <div
                v-for="(log, idx) in projectInfo.WorkerAttachmentLogs"
                :key="`w-${idx}`"
                class="project-info__field-value-col"
              >
                <span class="project-info__field-value-col-time"
                  >{{ formatDate(log.CreatedAt) }}&nbsp;</span
                >
                <span class="project-info__field-value-col-action">{{
                  log.Message
                }}</span>
              </div>
            </div>

            <div
              v-if="projectInfo.ClientChangeRecords?.length"
              class="project-info__field project-info__field--col"
            >
              <div class="project-info__field-name">Клиенты и роли:</div>
              <div
                v-for="(r, idx) in projectInfo.ClientChangeRecords"
                :key="`c-${idx}`"
                class="project-info__field-value-col"
              >
                <span class="project-info__field-value-col-time"
                  >{{ formatDate(r.RecordDate) }}&nbsp;</span
                >
                <span class="project-info__field-value-col-action">
                  [{{ r.Author?.Name }}]
                  {{ r.RecordType === 0 ? "добавлен" : "удалён" }}&nbsp;
                </span>
                <router-link
                  v-if="r.Object"
                  class="project-info__field-value-col-link"
                  :to="{
                    query: {
                      page: 'client',
                      id: r.Object.Id,
                    },
                  }"
                >
                  {{ r.Object.Name }}
                </router-link>
              </div>
            </div>

            <div
              v-if="projectInfo.PersonChangeRecords?.length"
              class="project-info__field project-info__field--col"
            >
              <div class="project-info__field-name">Контакты:</div>
              <div
                v-for="(r, idx) in projectInfo.PersonChangeRecords"
                :key="`p-${idx}`"
                class="project-info__field-value-col"
              >
                <span class="project-info__field-value-col-time"
                  >{{ formatDate(r.RecordDate) }}&nbsp;</span
                >
                <span class="project-info__field-value-col-action">
                  [{{ r.Author?.Name }}]
                  {{ r.RecordType === 0 ? "добавлен" : "удалён" }}&nbsp;
                </span>
                <span class="project-info__field-value-col-person">{{
                  r.Object?.Name
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #rules>
		<!-- <div>fvbadsfvasfvS</div> -->
        <main-permitions-tab
					:container="rulesContainer"
					:entity-id="projectIdRef"
					:can-edit="canEditRules"
					@save="onClose"
					@refresh="refreshRules"
          @cancel="onClose"
					type="project"
				/>
      </template>
    </app-tabs-old>
  </base-modal>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import moment from "moment";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import AppTabsOld from "@/components/ui-kit/tabs/AppTabsOld.vue";
import AppLists from "@/components/ui-kit/lists/AppLists.vue";
import { ProjectApi } from "@/ api/ProjectApi";
import type { ProjectInfoFull } from "@/models/interfaces/project/project-models";
import { CommonEntityRecord } from "@/models/interfaces/common";
import { projectPageStore } from "@/store/project-page";
// import ProjectAccessRulesTab from "../permitions/ProjectAccessRulesTab.vue";
import MainPermitionsTab from "../../permitions/MainPermitionsTab.vue";
import { EntityRulesContainer } from "@/models/interfaces/access/entity-rules";
import { workerStore } from "@/store/worker";
import { AccessApi } from "@/ api/AccessApi";

const PROJECT_SEGMENT = 0;

const route = useRoute();
const projectPage = projectPageStore();
const worker = workerStore();

// const tabs = ref([
// 	{ id: 0, title: "Информация о клиенте", slotName: "info" },
// ]);

const tabs = computed(() =>
  projectPage.project?.RuleAccess == 1
    ? [
        { id: 0, title: "Информация о проекте", slotName: "info" },
        { id: 1, title: "Права доступа", slotName: "rules" },
      ]
    : [
        { id: 0, title: "Информация о проекте", slotName: "info" },
      ]
)

// const tabs = [
//   { id: 0, title: "Информация о проекте", slotName: "info" },
//   { id: 1, title: "Права доступа", slotName: "rules" },
// ];

const $modal = ref<typeof BaseModal | null>(null);
const isActive = ref(false);
const $lists = ref<InstanceType<typeof AppLists> | null>(null);

const rulesContainer = ref<EntityRulesContainer | null>(null);
const canEditRules = computed(
  () =>
    !!worker.workerProfile?.IsAdmin || projectPage.project?.RuleAccess === 1,
);

const activeTab = ref<number>(0);
const isLoading = ref(false);
const projectInfo = ref<ProjectInfoFull | null>(null);
const projectIdRef = ref<number>(0);
const tags = ref<CommonEntityRecord[]>([]);

const formatDate = (date: string | undefined | null) => {
  if (!date) return "";
  return moment(date).format("HH:mm DD.MM.YYYY");
};

watch(activeTab, () => {
  $lists.value?.close();
});

const onOpen = async (projectId: number, projectTags: CommonEntityRecord[] = []) => {
  try {
    projectIdRef.value = projectId;
    // clientIdRef.value = projectId;
    tags.value = projectTags;
    isLoading.value = true;
    activeTab.value = 0;
    projectInfo.value = null;
    $modal.value?.onOpen();
    isActive.value = true;

    projectInfo.value = await ProjectApi.getProjectInfo(projectId);
    await refreshRules();
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

const onClose = () => {
	isActive.value = false;
	$modal.value?.onClose();
}

onMounted(() => {
  window.addEventListener("keydown", handleEsc, true);
});

onUnmounted(() => {
  window.removeEventListener("keydown", handleEsc, true);
});

const handleEsc = async (e: KeyboardEvent) => {
  if (e.key !== "Escape") {
		return;
  }
  if (!isActive.value) {
		return;
  }

  e.stopPropagation();
  $modal.value?.onClose();
};

// watch(projectPage.project?.RuleAccess,() => { if(projectPage.project?.RuleAccess ==1) tabs.value = [
//   { id: 0, title: "Информация о проекте", slotName: "info" },
//   { id: 1, title: "Права доступа", slotName: "rules" },
// ];})

defineExpose({ onOpen });

const refreshRules = async () => {
  try {
    const rulesGiver = await AccessApi.getProjectAccessRules(projectIdRef.value);
    rulesContainer.value = rulesGiver?.Container ?? null;
  } catch (e) {
    console.error(e);
  }
};
</script>

<style scoped lang="scss">
@import "@/styles/color.scss";

:deep(.app-tabs) {
  overflow: hidden;
}

:deep(.app-tabs__content) {
  overflow: hidden;
}

:deep(.app-tabs__content-tab) {
  overflow-y: auto;
}

.project-info {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 12px 16px;

  &__header {
    display: flex;
    align-items: stretch;
    width: 100%;
    gap: 8px;

    &-left,
    &-right {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    &-left {
      flex: 2;
    }
    &-right {
      flex: 1;
    }
  }

  &__records {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  &__field {
    margin-bottom: 4px;
    font-size: 14px;
    line-height: 18px;
    overflow-wrap: anywhere;
    word-break: break-word;

    &--col {
      display: flex;
      flex-direction: column;
    }

    &-name {
      color: $color-text_main;
      font-weight: 500;
    }

    &-value {
      color: $color-text_main;
    }

    &-value-col {
      display: inline-block;
      overflow-wrap: anywhere;
      word-break: break-word;

      &-time {
        color: #979797;
      }

      &-name {
        color: $color-text_main;
      }

      &-action {
        margin-left: 2px;
        color: $color-text_main;
      }

      &-person {
        color: $color-text_main;
        font-style: italic;
      }

      &-link {
        color: #396742;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
